/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/m-serch-setting': {
    width: 25,
    height: 20,
    viewBox: '0 0 25 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.509 11.623a1.754 1.754 0 100-3.509 1.754 1.754 0 000 3.509zm0 1.754a3.509 3.509 0 100-7.017 3.509 3.509 0 000 7.017zM12.28 5.263a1.754 1.754 0 100-3.509 1.754 1.754 0 000 3.51zm0 1.755a3.509 3.509 0 100-7.018 3.509 3.509 0 000 7.018zM21.491 14.474a1.754 1.754 0 100-3.509 1.754 1.754 0 000 3.509zm0 1.754a3.509 3.509 0 100-7.018 3.509 3.509 0 000 7.018z" _fill="#000"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M2.412 6.798V0h1.755v6.798H2.412zM2.412 19.079V12.06h1.755v7.018H2.412zM11.404 19.079V6.359h1.754v12.72h-1.754zM20.395 10.307V0h1.754v10.307h-1.754zM20.395 19.079v-3.947h1.754v3.947h-1.754z" _fill="#000"/>'
  }
})
